import { render, staticRenderFns } from "./blog16.vue?vue&type=template&id=0f8af052"
import script from "./blog16.vue?vue&type=script&lang=js"
export * from "./blog16.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports